import {
  LivretEleveMatiere,
  TypePositionnement,
} from '@teetsh/app/src/containers/Livrets/types/livret';
import { CompetenceItem, TypeCompetenceItem } from './types';

export function matieresToTableRows(
  mode: TypePositionnement,
  matieres: LivretEleveMatiere[],
  readonly: boolean,
): CompetenceItem[] {
  return (matieres || []).reduce((acc, mat) => {
    if ((mat?.domaines || []).length === 0) {
      const competencesRows = (mat?.competences || []).map(c => ({
        id: c?.id,
        matiereId: mat.id,
        competence: c,
        remark: mat.remark,
        note: mode === 'competence' ? c?.note : mat.note,
        type: 'competence' as TypeCompetenceItem,
      }));
      const rows = [...acc, ...competencesRows];
      if (readonly) {
        if (competencesRows.length === 0) {
          return [
            ...rows,
            {
              id: mat.id,
              type: 'competence' as TypeCompetenceItem,
              matiereId: mat.id,
              note: mat.note,
              remark: mat.remark,
            },
          ];
        }
        return rows;
      }
      return [
        ...rows,
        {
          id: mat.id,
          type: 'add-competence' as TypeCompetenceItem,
          matiereId: mat.id,
          note: mat.note,
          remark: mat.remark,
        },
      ];
    }
    return (mat?.domaines || []).reduce((accc, dom) => {
      const competencesRows = (dom?.competences || []).map(c => ({
        id: c?.id || dom.id,
        type: 'competence' as TypeCompetenceItem,
        matiereId: mat.id,
        domaineId: dom.id,
        competence: c,
        remark: mat.remark,
        note: mode === 'competence' ? c?.note : dom.note,
      }));
      const rows = [...accc, ...competencesRows];
      if (readonly) {
        if (competencesRows.length === 0) {
          return [
            ...rows,
            {
              id: dom.id,
              type: 'competence' as TypeCompetenceItem,
              matiereId: mat.id,
              domaineId: dom.id,
              note: dom.note,
              remark: mat.remark,
            },
          ];
        }
        return rows;
      }
      return [
        ...rows,
        {
          id: dom.id,
          type: 'add-competence' as TypeCompetenceItem,
          matiereId: mat.id,
          domaineId: dom.id,
          note: dom.note,
          remark: mat.remark,
        },
      ];
    }, acc);
  }, []);
}
